import { render } from "./ListaDocumentosComponent.vue?vue&type=template&id=e37e5d70&scoped=true"
import script from "./ListaDocumentosComponent.vue?vue&type=script&lang=js"
export * from "./ListaDocumentosComponent.vue?vue&type=script&lang=js"

import "./ListaDocumentosComponent.vue?vue&type=style&index=0&id=e37e5d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e37e5d70"]])

export default __exports__